(() => {
  function getCartSectionId() {
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && cartDrawer.dataset.sectionId) {
      return cartDrawer.dataset.sectionId;
    }
    const cart = document.querySelector("cart-page");
    if (cart && cart.dataset.sectionId) {
      return cart.dataset.sectionId;
    }
    return "cart-notification-popup-content";
  }

  function parseSectionHtml(sectionHtml) {
    if (!sectionHtml) return null;
    return new DOMParser().parseFromString(sectionHtml, "text/html");
  }

  async function fetchSectionHtml(sectionId, target) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    const url = target === "cart" ? `/cart?section_id=${sectionId}` : `${root}?section_id=${sectionId}`;
    const response = await fetch(url, { cache: "no-store" });
    if (!response.ok) {
      throw new Error("Failed to fetch cart section");
    }
    return response.text();
  }

  window.juoReloadCart = async (parsedState) => {
    const cartDrawer = document.querySelector("cart-drawer");
    const cart = document.querySelector("cart-page");
    const popup = document.querySelector("#CartNotificationPopup");
    const cartSectionId = getCartSectionId();


    const impulseDrawerForm = document.getElementById("CartDrawerForm");
    if (
      impulseDrawerForm &&
      !cartDrawer &&
      window.theme &&
      window.theme.cart &&
      typeof window.theme.cart.getCartProductMarkup === "function"
    ) {
      try {
        document.dispatchEvent(new CustomEvent("cart:build"));
        return;
      } catch {

      }
    }

    try {
      const target = cart ? "cart" : "drawer";
      const sectionText = await fetchSectionHtml(cartSectionId, target);
      const html = parseSectionHtml(sectionText);
      const state = parsedState || { id: null, quantity: 1 };

      if (cart) {
        cart.updateEmptyStatus(false);
        cart.purchaseHandler(html, state);
      } else if (cartDrawer) {
        cartDrawer.purchaseHandler(html, state);
      } else if (popup) {
        popup.purchaseHandler(html, state);
      } else if (impulseDrawerForm && window.theme && window.theme.cart) {
        document.dispatchEvent(new CustomEvent("cart:build"));
      }
    } catch {
      if (
        impulseDrawerForm &&
        window.theme &&
        window.theme.cart &&
        typeof window.theme.cart.getCartProductMarkup === "function"
      ) {
        try {
          document.dispatchEvent(new CustomEvent("cart:build"));
          return;
        } catch {

        }
      }
      window.location.href = "/cart";
    }
  };

  document.addEventListener("reload-side-cart", () => {
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && cartDrawer.update) {
      cartDrawer.update();
      return;
    }
    if (window.juoReloadCart) {
      window.juoReloadCart({ id: null, quantity: 1 });
    }
  });

  document.addEventListener(
    "click",
    async (event) => {
      const removeButton = event.target.closest("cart-remove-button");
      if (!removeButton) return;

      const cartItem = removeButton.closest("cart-item");
      if (removeButton.hasAttribute("data-juo-removing")) return;
      const itemKey = cartItem ? cartItem.dataset.key : null;
      const index = cartItem ? cartItem.dataset.index : removeButton.dataset.index;
      if (!itemKey && index == null) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      removeButton.setAttribute("data-juo-removing", "true");
      if (cartItem && cartItem.setLoading) {
        cartItem.setLoading(true);
        cartItem.setDisabled?.(true);
      }

      const cartSectionId = getCartSectionId();
      const payload = {
        quantity: 0,
        sections: [cartSectionId],
        sections_url: window.location.pathname,
      };
      if (itemKey) {
        payload.id = itemKey;
      } else {
        payload.line = Number.parseInt(index, 10);
      }

      const root =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
        "/";
      const changeUrl =
        (window.routes && window.routes.cart_change_url) ||
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_change_url) ||
        `${root}cart/change.js`;
      const normalizedChangeUrl = changeUrl.endsWith(".js")
        ? changeUrl
        : `${changeUrl}.js`;

      const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
      try {
        let attempt = 0;
        let responseData = null;
        let lastStatus = null;
        while (attempt < 3) {
          const response = await fetch(normalizedChangeUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
              Accept: "application/json",
            },
            body: JSON.stringify(payload),
          });
          lastStatus = response.status;
          const responseText = await response.text();
          try {
            responseData = JSON.parse(responseText);
          } catch {

          }
          if (response.ok) {
            break;
          }
          if (response.status === 429) {
            const waitMs = attempt === 0 ? 500 : 1500;
            await sleep(waitMs);
            attempt += 1;
            continue;
          }
          throw new Error("Cart change failed");
        }
        if (lastStatus === 429) {
          const bodyElement = document.querySelector("body-element");
          if (bodyElement && bodyElement.showNotification) {
            bodyElement.showNotification(
              "Zbyt wiele zapytań do koszyka. Spróbuj ponownie za chwilę.",
              "warning"
            );
          }
        }
        if (responseData && Array.isArray(responseData.items) && itemKey) {
          const stillExistsIndex = responseData.items.findIndex(
            (item) => item && item.key === itemKey
          );
          if (stillExistsIndex !== -1) {
            await fetch(normalizedChangeUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
                Accept: "application/json",
              },
              body: JSON.stringify({
                line: stillExistsIndex + 1,
                quantity: 0,
                sections: [cartSectionId],
                sections_url: window.location.pathname,
              }),
            });
          }
        }
      } catch {

      } finally {
        document.dispatchEvent(new Event("reload-side-cart"));
        removeButton.removeAttribute("data-juo-removing");
        if (cartItem && cartItem.setLoading) {
          cartItem.setLoading(false);
          cartItem.setDisabled?.(false);
        }
      }
    },
    true
  );


  function juoHideUpcartUnderscoreLineProperties() {
    const popup = document.getElementById("CartPopup");
    if (!popup) return;
    popup
      .querySelectorAll(
        ".upcart-item-property:not(.upcart-item-property-subscription)"
      )
      .forEach((el) => {
        const strong = el.querySelector("strong");
        const label = strong
          ? strong.textContent.trim()
          : el.textContent.trim();
        if (label.startsWith("_")) {
          el.setAttribute("hidden", "");
        }
      });
  }

  let juoUpcartPropsTimer;
  function juoScheduleUpcartPropsHide() {
    clearTimeout(juoUpcartPropsTimer);
    juoUpcartPropsTimer = setTimeout(juoHideUpcartUnderscoreLineProperties, 50);
  }

  document.addEventListener("DOMContentLoaded", juoScheduleUpcartPropsHide);
  document.addEventListener("reload-side-cart", juoScheduleUpcartPropsHide);

  if (document.body) {
    new MutationObserver(juoScheduleUpcartPropsHide).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();
